export default "__VITE_ASSET__mVKvfTc9__"